import {
  GoogleMap,
  Marker,
  MarkerClusterer,
  useJsApiLoader,
} from '@react-google-maps/api';
import * as React from 'react';
import styled from 'styled-components';
import DpdMap from './DpdMap';

interface Props {
  children: any;
}

const MapWrapper = styled.div`
  width: 100%;
  height: 520px;
  overflow: hidden;
  padding: 15px;
`;

function DpdMapWrapper(props: Props) {
  return (
    <MapWrapper className="w-full h-[520px] overflow-hidden">
      {props.children}
    </MapWrapper>
  );
}

export default DpdMapWrapper;
